/* Commenting the following code for cleanup.ray using AI Agent. 21/09/2026. Comment Start */
// export const BASE_URL = "http://localhost:8000"
// export const BASE_URL = "https://dev.selftrainai.com"
/* Commenting end. ray using AI Agent. 21/09/2026 */
/* Added the following code for cleanup.ray using AI Agent. 21/09/2026. Code Start */
/* Commenting the following code for newbie.ray using AI Agent. 01/10/2026. Comment Start */
// /**
//  * API base URL from CRA env (REACT_APP_API_URL). Falls back to local backend.
//  * Set in .env / hosting config, e.g. REACT_APP_API_URL=https://dev.selftrainai.com
//  */
// export const BASE_URL =
//   (typeof process !== "undefined" &&
//     process.env &&
//     process.env.REACT_APP_API_URL &&
//     String(process.env.REACT_APP_API_URL).trim()) ||
//   "http://localhost:8000";
/* Commenting end. ray using AI Agent. 01/10/2026 */
/* Added the following code for newbie.ray using AI Agent. 01/10/2026. Code Start */
/** Deployed backend. Builds must never fall back to a localhost backend. */
const DEPLOYED_API_URL = "https://dev.selftrainai.com";

/**
 * API base URL. REACT_APP_API_URL (CRA env) overrides it, e.g. for local
 * backend development; otherwise the deployed backend is used.
 */
/* Commenting the following code for deployfix.Ray using AI Agent. 09/10/2026. Comment Start */
// export const BASE_URL =
//   (typeof process !== "undefined" &&
//     process.env &&
//     process.env.REACT_APP_API_URL &&
//     String(process.env.REACT_APP_API_URL).trim()) ||
//   DEPLOYED_API_URL;
/* Commenting end. Ray using AI Agent. 09/10/2026 */
/* Added the following code for deployfix.Ray using AI Agent. 09/10/2026. Code Start */
// No `typeof process` guard: CRA only inlines process.env.REACT_APP_* at build time,
// and `process` does not exist in the browser, so the guard always fell back to DEPLOYED_API_URL.
export const BASE_URL =
  String(process.env.REACT_APP_API_URL || "").trim() || DEPLOYED_API_URL;
/* Code end. Ray using AI Agent. 09/10/2026 */
/* Code end. ray using AI Agent. 01/10/2026 */

/**
 * Phase 0 feature-flag skeleton (env-driven). Used by later Phase 1+ cutovers.
 * Enable with REACT_APP_* = "true" in frontend env.
 */
export const FEATURE_FLAGS = {
  lessonEngineV2: process.env.REACT_APP_LESSON_ENGINE_V2 === "true",
  quizGradeServer: process.env.REACT_APP_QUIZ_GRADE_SERVER === "true",
  tryItPyodide: process.env.REACT_APP_TRYIT_PYODIDE === "true",
  /* Added the following code for newbie.ray using AI Agent. 01/10/2026. Code Start */
  // Capstone Project lab: optional in-browser (Pyodide) practice runs; Testing always uses the server.
  capstonePyodide: process.env.REACT_APP_CAPSTONE_PYODIDE === "true",
  /* Code end. ray using AI Agent. 01/10/2026 */
};
/* Code end. ray using AI Agent. 21/09/2026 */